import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { BroadcastWhatsapp } from 'src/app/models/BroadcastWhatsapp';
import { BroadcastContact } from 'src/app/models/BroadcastContact';
import { BroadcastsWhatsappService } from 'src/app/shared/services/broadcasts-whatsapp.service';

import { IMPORTING, SCHEDULED } from '../../../models/BroadcastStatus';
import { PaginatedResult } from './../../../shared/model/paginated-result';
import { CopyService } from './../../../shared/services/copy.service';
import { ToastService } from './../../../shared/components/toast/toast.service';

@Component({
  selector: 'app-view-broadcast-whatsapp',
  templateUrl: './view-broadcast-whatsapp.component.html',
  styleUrls: ['./view-broadcast-whatsapp.component.scss']
})
export class ViewBroadcastWhatsappComponent implements OnInit, OnDestroy {

  page = 1;
  perPage = 8;
  broadcastId: string;
  broadcast: BroadcastWhatsapp;
  contacts: PaginatedResult<BroadcastContact[]>;

  /** A tela inteira depende do broadcast: sem flag, ela fica em branco até chegar. */
  loading = true;
  loadingContacts = true;

  subscriptions: Subscription[] = [];

  get isScheduled() {
    return this.broadcast.broadcast_whatsapp_status_id === SCHEDULED;
  }

  get isImporting() {
    return this.broadcast.broadcast_whatsapp_status_id === IMPORTING;
  }

  get status() {
    return this.broadcast.status?.status ?? '-';
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private copyService: CopyService,
    private broadcastsWhatsappService: BroadcastsWhatsappService,
    private toastService: ToastService
  ) { }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.params.subscribe(params => {
        this.broadcastId = params.id;
        this.findById();
        this.listContacts();
      })
    );

    this.subscriptions.push(
      this.route.queryParams.subscribe(params => {
        const page = params.page || 1;
        this.page = page;
        this.listContacts();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  findById() {
    this.loading = true;
    this.subscriptions.push(
      this.broadcastsWhatsappService.findById(this.broadcastId).subscribe(
        broadcast => {
          this.loading = false;
          this.broadcast = broadcast
        },
        () => {
          // CU-86akkurac — volta para a lista de WhatsApp, não para a de SMS
          // (`/broadcasts`), e diz por quê: o interceptor não avisa 404.
          this.loading = false;
          this.toastService.error('Não foi possível carregar este envio de WhatsApp.');
          this.router.navigate(['/broadcasts-whatsapp']);
        }
      )
    );
  }

  listContacts(): void {
    this.loadingContacts = true;
    this.subscriptions.push(
      this.broadcastsWhatsappService
        .listContacts(this.broadcastId, this.page, this.perPage)
        .subscribe({
          next: contacts => {
            this.loadingContacts = false;
            this.contacts = contacts;
          },
          error: () => { this.loadingContacts = false; },
        })
    );
  }

  getStatus(contact: BroadcastContact): string {
    if (contact.sent_date && !contact.cancelled) {
      return 'Enviado';
    }

    if (contact.cancelled) {
      return 'Cancelado';
    }

    return 'Pendente';
  }

  pageChanged(page: any): void {
    this.router
      .navigate(['/broadcasts-whatsapp/view', this.broadcast.id], { queryParams: { page } });
  }

  copyUrl(): void {
    this.copyService.copy('url', 'URL copiada com sucesso!');
  }

  copyShortUrl(): void {
    this.copyService.copy('short_url', 'URL Curta copiada com sucesso!');
  }

}
